module.exports = __webpack_public_path__ + "static/assets/5461bb73dfa05d9213e5f6a95a0b266d.svg";